import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Package, ArrowRight } from "lucide-react";

interface AlternativeBadgeProps {
  productNaam: string | null;
  locatie: string | null;
  voorraad: number | null;
  matchType: string | null;
  sku: string | null;
  eenheid: string | null;
}

const matchTypeLabels: Record<string, string> = {
  same_product_other_location: "Andere locatie",
  zzz_stripped: "ZZZ vervanger",
  known_replacement: "Bekend alternatief",
  size_variant: "Andere maat",
  brand_similar: "Zelfde merk",
  color_code: "Zelfde kleurcode",
};

export const AlternativeBadge = ({ productNaam, locatie, voorraad, matchType, sku, eenheid }: AlternativeBadgeProps) => {
  if (!productNaam) {
    return (
      <span className="text-xs text-muted-foreground italic">Geen alternatief</span>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className="gap-1 cursor-help bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-950 dark:border-emerald-800 dark:text-emerald-300"
          >
            <Package className="h-3 w-3" />
            <ArrowRight className="h-3 w-3" />
            <span className="max-w-[100px] truncate">{productNaam}</span>
            {sku && (
              <span className="text-[10px] opacity-75 font-mono">({sku})</span>
            )}
            {voorraad && voorraad > 0 && (
              <span className="font-semibold">{voorraad}x</span>
            )}
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-sm">
          <div className="space-y-2">
            <p className="font-medium">Alternatief product gevonden</p>
            <p className="text-sm">{productNaam}</p>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-muted-foreground">
              <span>SKU: <span className="font-mono">{sku || "-"}</span></span>
              <span>Eenheid: {eenheid || "-"}</span>
              <span>Locatie: {locatie || "-"}</span>
              <span>Voorraad: {voorraad || 0}</span>
            </div>
            {matchType && (
              <p className="text-xs text-muted-foreground italic border-t pt-1">
                {matchTypeLabels[matchType] || matchType}
              </p>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
